module.exports = __webpack_public_path__ + "static/img/kot.33cd2971.webp";